import React from 'react';

import {TagSchema} from 'constants/RegistryConstants';
import {isSchemaTag, SchemaTag} from 'folder-items/FileConstants';
import TagValueViewer from 'metadata/TagValueViewer';
import {ChildEntityDataForTab} from 'registry/child-entities/ChildEntityConstants';
import CreateChildEntityButton from 'registry/child-entities/CreateChildEntityButton';
import {tagsToDict} from 'samples/SampleUtil';
import getTestProps from 'test/lib/cypress/getTestProps';
import BenchChip from 'ui-library/chips/BenchChip';
import {ChipSize} from 'ui-library/chips/Chip';
import PartyList from 'ui-library/PartyList';
import {Cell, Column, Table} from 'ui-library/simple-table/SimpleTable';
import {readableTime} from 'util/DateUtil';

interface Props {
  childEntities: Array<ChildEntityDataForTab>;
  childEntitySchema: TagSchema;
  parentEntityId: string;
  offset: number;
  setOffset: (offset: number) => void;
  total: number;
}

export default function ChildEntityTable(props: Props): JSX.Element | null {
  const childEntitiesTagsById = props.childEntities.map((childEntity) =>
    tagsToDict(childEntity.tags.filter((tag): tag is SchemaTag => isSchemaTag(tag)))
  );

  return (
    <div {...getTestProps({component: 'ChildEntityTable', element: 'root'})}>
      <Table
        emptyTableText="No entities"
        numRows={props.childEntities.length}
        pagination={{offset: props.offset, limit: 100, total: props.total}}
        setOffset={props.setOffset}
      >
        <Column
          header={
            <Cell>
              Entity
              <CreateChildEntityButton
                parentEntityId={props.parentEntityId}
                childEntitySchema={props.childEntitySchema}
              />
            </Cell>
          }
          renderCell={(rowIndex: number) => (
            <Cell>
              <BenchChip id={props.childEntities[rowIndex].id} size={ChipSize.SMALL} />
            </Cell>
          )}
        />
        <Column
          header="Created"
          renderCell={(rowIndex: number) => (
            <Cell>{readableTime(props.childEntities[rowIndex].createdAt, {showTime: false})}</Cell>
          )}
        />
        <Column
          header="Authors"
          renderCell={(rowIndex: number) => (
            <Cell>
              <PartyList parties={props.childEntities[rowIndex].authors} useAvatar={true} />
            </Cell>
          )}
        />
        {props.childEntitySchema.fields.map((field) => (
          <Column
            header={field.name}
            key={field.id}
            renderCell={(rowIndex: number) => (
              <Cell>
                <TagValueViewer tag={childEntitiesTagsById[rowIndex][field.id]} />
              </Cell>
            )}
          />
        ))}
      </Table>
    </div>
  );
}
